module.exports = __webpack_public_path__ + "img/11157927000156.082a8f04.png";